<script setup lang="ts">
    import type { MenuItem as WoomMenuItem } from '~/graphql/generated';

    export interface DestopMenuItemTextProps {
        item: WoomMenuItem;
        isFirstLevel?: boolean;
    }
    defineProps<DestopMenuItemTextProps>();
</script>
<template>
    <div :class="['flex items-center gap-4', { 'py-2.5 lg:py-4': !isFirstLevel }]">
        <lazy-org-menu-feature
            v-if="item.image"
            class="w-24 shrink-0 lg:hidden"
            :featured="item" />
        <div class="text-left">
            <div class="font-bold">
                <renderer-html :content="woomTextFormat(item.title)" />
            </div>
            <div
                v-if="item.subtitle"
                class="block whitespace-pre-line text-xs font-book text-woom-grey-taupe">
                <renderer-html :content="woomTextFormat(item?.subtitle)" />
            </div>
        </div>
    </div>
    <lazy-woom-icon-chevron-right
        v-if="!!item.items?.length && !item.image && !isFirstLevel"
        class="h-4 w-4 fill-current transition-colors" />
</template>
